import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import 'moment/locale/pt-br';
import messages from './messages';

moment.locale('pt-br');
const localizer = momentLocalizer(moment);

const VIEWS = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  AGENDA: 'agenda'
};

const Schedule = (props) => {
  const {
    events = [],
    onChange,
    onSelectSlot,
    eventPropGetter,
    onSelectEvent = () => {},
    defaultView,
    step,
    min,
    max
  } = props;
  let { components } = props;
  const [view, setView] = useState(defaultView);

  const handleRangeChange = (dates, nextView) => {
    const currentView = nextView ?? view;

    if (!onChange) {
      return;
    }

    if (nextView) {
      setView(nextView);
    }

    if (currentView === VIEWS.WEEK) {
      onChange(dates[0], dates[6]);
      return;
    }

    if (currentView === VIEWS.DAY) {
      onChange(dates[0], dates[0]);
      return;
    }

    if (currentView === VIEWS.MONTH) {
      onChange(
        moment(dates.start).startOf('day'),
        moment(dates.end).startOf('day')
      );
      return;
    }

    onChange(dates.start, dates.end);
  };

  const handleSelectSlot = ({ start, end, ...rest }) => {
    if (!onSelectSlot) {
      return;
    }

    if (view === VIEWS.MONTH) {
      start = moment(start).startOf('day');
      end = moment(end).endOf('day');

      onSelectSlot({ ...rest, start, end });
      return;
    }

    onSelectSlot({ ...rest, start, end });
  };

  if (components && !components.header) {
    components = {
      ...components,
      header: ({ date }) => {
        if (view === 'month') {
          return moment(date).format('dddd');
        }

        if (view === 'week') {
          return (
            <div className="gx-text-dark">
              <div>{moment(date).format('dddd')}</div>
              <div className="gx-font-weight-normal">
                {moment(date).format('DD/MM')}
              </div>
            </div>
          );
        }

        return null;
      }
    };
  }

  return (
    <div>
      <Calendar
        className="gx-schedule"
        step={step}
        timeslots={1}
        components={components}
        localizer={localizer}
        messages={messages}
        events={events}
        min={min}
        max={max}
        tooltipAccessor={() => null}
        onSelectEvent={onSelectEvent}
        startAccessor="start"
        eventPropGetter={eventPropGetter}
        endAccessor="end"
        onRangeChange={handleRangeChange}
        defaultView={defaultView}
        selectable={view === 'week' || view === 'day'}
        onSelectSlot={handleSelectSlot}
      />
    </div>
  );
};

export default Schedule;
